import { render, staticRenderFns } from "./sellerReport.vue?vue&type=template&id=67ca513d&"
import script from "./sellerReport.vue?vue&type=script&lang=js&"
export * from "./sellerReport.vue?vue&type=script&lang=js&"
import style0 from "./sellerReport.vue?vue&type=style&index=0&id=67ca513d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports